export default __webpack_public_path__ + "static/runway-04-721bb7648e201f13b44c79edd8c35d21.mp4";